import { apiPrefix } from "./common";

import axios from "axios";

export default {
  apiWebsitePrefix(path) {
    return apiPrefix("/websites" + (path ? "/" + path : ""));
  },

  getWebsites() {
    return axios.get(this.apiWebsitePrefix());
  },

  // postWebsite(form = {}) {
  //   return axios.post(this.apiWebsitePrefix(), form);
  // },

  getWebsite(website_id) {
    return axios.get(this.apiWebsitePrefix(website_id));
  },

  putWebsite(website_id, form = {}) {
    return axios.put(this.apiWebsitePrefix(website_id), form);
  },
};
